/**
 * @fileoverview General application configuration.
 * @description Holds display-level app metadata (name, version, copyright year) used in the UI
 * footer and the browser tab title, and re-exposes the mock-API and right-click flags alongside
 * it so app-wide settings read from one place. The app name comes from configuration
 * (VITE_APP_NAME) so each environment can show its own name; when it isn't set, the local dev
 * server shows "InsightBox Local" and every other run shows "InsightBox".
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import { env } from '@/config/env'

// Names used when VITE_APP_NAME is unset or empty (e.g. an older local .env that predates the
// variable), so the UI never renders a blank or "undefined" app name. Only the local Vite dev
// server (`pnpm dev`) is a dev-server run; every `vite build`, whatever its mode, is not.
const DEFAULT_APP_NAME = 'InsightBox'
const DEFAULT_LOCAL_APP_NAME = 'InsightBox Local'

export const appConfig = {
  name: env.appName || (env.isDevServer ? DEFAULT_LOCAL_APP_NAME : DEFAULT_APP_NAME),
  version: 'v2.4.1',
  copyrightYear: 2026,
  enableMockApi: env.enableMockApi,
  disableRightClick: env.disableRightClick,
}
